import { useMutation } from "react-query";
import createCampaign from "../services/createCampaign";

function useCreateCampaign() {
  return useMutation(["create-campaign"], createCampaign);
}

export default useCreateCampaign;
